import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/dfms-frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/html/dfms-frontend/node_modules/next/dist/client/app-dir/link.js");
